import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const ActionTooltipButton = ({ tooltip, tooltipId, children, ...buttonProps }) => (
    <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={tooltipId}>{tooltip}</Tooltip>}
    >
        <Button {...buttonProps}>{children}</Button>
    </OverlayTrigger>
);

export default ActionTooltipButton;
